import apiClient from './apiClient';

// Tüm blog yazılarını getir
export const getBlogPosts = async (locale = 'tr', page = 1, pageSize = 10, filters = null) => {
  try {
    const params = {
      locale,
      'pagination[page]': page,
      'pagination[pageSize]': pageSize,
      populate: '*',
      sort: 'publishedAt:desc',
    };
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (typeof value === 'object') {
          Object.entries(value).forEach(([subKey, subValue]) => {
            params[`filters[${key}][${subKey}]`] = subValue;
          });
        } else {
          params[`filters[${key}]`] = value;
        }
      });
    }
    
    const response = await apiClient.get('/articles', { params });
    console.log('Strapi API ham yanıt:', response);
    return response.data;
  } catch (error) {
    console.error('Blog yazıları getirilirken hata oluştu:', error);
    throw error;
  }
};

// Belirli bir slug'a sahip blog yazısını getir
export const getBlogPostBySlug = async (slug, locale = 'tr') => {
  try {
    const response = await apiClient.get('/articles', {
      params: {
        locale,
        'filters[slug][$eq]': slug,
        populate: '*',
      },
    });
    return response.data || null;
  } catch (error) {
    console.error(`${slug} slug'ına sahip blog yazısı getirilirken hata oluştu:`, error);
    throw error;
  }
};

// Tüm kategorileri getir
export const getCategories = async (locale = 'tr') => {
  try {
    // Strapi v4 API endpoint'i
    const response = await apiClient.get('/categories', {
      params: {
        locale,
        populate: '*',
      },
    });
    
    console.log('Kategoriler API yanıtı:', response.data);
    return response.data;
  } catch (error) {
    console.error('Kategoriler getirilirken hata oluştu:', error);
    throw error;
  }
};

// YouTube video ID'sini çıkarma fonksiyonu - geliştirilmiş versiyon
export const getYoutubeVideoId = (url) => {
  if (!url) return null;
  
  // URL'yi temizle ve normalize et
  let cleanUrl = url.trim();
  
  // Eğer URL bir string değilse veya boşsa null dön
  if (typeof cleanUrl !== 'string' || cleanUrl === '') {
    console.log('Geçersiz URL formatı:', url);
    return null;
  }
  
  try {
    // Doğrudan video ID girilmiş olabilir
    if (cleanUrl.length === 11) {
      console.log('Doğrudan video ID girilmiş olabilir:', cleanUrl);
      return cleanUrl;
    }
    
    // YouTube Shorts için özel işleme
    if (cleanUrl.includes('youtube.com/shorts/')) {
      // eslint-disable-next-line no-useless-escape
      const shortsMatch = cleanUrl.match(/youtube\.com\/shorts\/([^\/?&]+)/);
      if (shortsMatch && shortsMatch[1] && shortsMatch[1].length === 11) {
        console.log('YouTube Shorts video ID bulundu:', shortsMatch[1]);
        return shortsMatch[1];
      }
    }
    
    /* eslint-disable no-useless-escape */
    // Tüm olası YouTube URL formatları için regex
    const patterns = [
      // Standart: https://www.youtube.com/watch?v=VIDEO_ID
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube\.com\/e\/|youtube\.com\/user\/\S+\/\S+\/|youtube\.com\/\S+\/\S+\/|youtube\.com\/attribution_link\?.*v%3D|youtube\.com\/attribution_link\?.*v=)([^#\&\?\n]*)/,
      // Kısa URL: https://youtu.be/VIDEO_ID
      /youtu\.be\/([^#\&\?\n]*)/,
      // Embed URL: https://www.youtube.com/embed/VIDEO_ID
      /youtube\.com\/embed\/([^#\&\?\n]*)/,
      // Eski format: https://www.youtube.com/v/VIDEO_ID
      /youtube\.com\/v\/([^#\&\?\n]*)/
    ];
    
    for (const pattern of patterns) {
      const match = cleanUrl.match(pattern);
      if (match && match[1] && match[1].length === 11) {
        console.log('Eşleşen pattern ile video ID bulundu:', match[1]);
        return match[1];
      }
    }
    
    // Genel regex (son çare)
    /* eslint-disable no-useless-escape */
    const generalRegex = /^.*(youtu.be\/+|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|shorts\/)([^#\&\?]*).*$/; // eslint-disable-line no-useless-escape
    const match = cleanUrl.match(generalRegex);
    if (match && match[2] && match[2].length === 11) {
      console.log('Genel regex ile video ID bulundu:', match[2]);
      return match[2];
    }
    
    console.log('Video ID bulunamadı, URL formatı desteklenmiyor:', cleanUrl);
    return null;
  } catch (error) {
    console.error('Video ID çıkarılırken hata oluştu:', error);
    return null;
  }
};

// YouTube embed URL'si oluştur
export const getYoutubeEmbedUrl = (url) => {
  const videoId = getYoutubeVideoId(url);
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

// YouTube thumbnail URL'si oluştur
export const getYoutubeThumbnailUrl = (url) => {
  const videoId = getYoutubeVideoId(url);
  return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
};
